module.exports = __webpack_public_path__ + "img/UI_loading_H5BG_02_bd211e7a3.jpg";